/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { ModalConfirm } from "@nordcloud/gnui";
import { showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";
import { usePatchPlan } from "../../hooks/useUpdatePlan/useUpdatePlan";

type Props = {
  planId: string;
  isPlanActive: boolean;
  isDeactivateModalOpen: boolean;
  onClose: () => void;
};

export function UpdatePlanStatus({
  planId,
  isPlanActive,
  isDeactivateModalOpen,
  onClose,
}: Props) {
  const [wasEnabled, setWasEnabled] = useState(isPlanActive);

  const success = () => {
    showSuccess(
      generateActionSuccessText("Plan")()(
        wasEnabled ? "deactivated" : "activated"
      )()
    );

    onClose();
  };

  const [patchPlan] = usePatchPlan({ onSuccess: success });

  function patchPlanStatus() {
    patchPlan({
      id: planId,
      enabled: !isPlanActive,
    });

    setWasEnabled(isPlanActive);
  }

  return (
    <ModalConfirm
      onClose={onClose}
      isOpen={isDeactivateModalOpen}
      confirm={patchPlanStatus}
      actionLabel={isPlanActive ? "Deactivate" : "Activate"}
      contentLabel={isPlanActive ? "Deactivate Plan" : "Activate Plan"}
    >
      {isPlanActive
        ? "Are you sure you want to deactivate Plan?"
        : "Are you sure you want to activate Plan?"}
    </ModalConfirm>
  );
}
